import LifeIdDrawer from './life-id-drawer';

export default LifeIdDrawer;
